import { render, staticRenderFns } from "./PrescriptionListItem.vue?vue&type=template&id=d1b9fc4c"
import script from "./PrescriptionListItem.vue?vue&type=script&lang=js"
export * from "./PrescriptionListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports